import { render, staticRenderFns } from "./index.vue?vue&type=template&id=a16744c2&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=a16744c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16744c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a16744c2')) {
      api.createRecord('a16744c2', component.options)
    } else {
      api.reload('a16744c2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=a16744c2&scoped=true&", function () {
      api.rerender('a16744c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/stat/otwooDept/index.vue"
export default component.exports